module.exports = __webpack_public_path__ + "static/media/map_animation.683ec19a.gif";